import React, {
  Fragment,
  useState,
  useEffect,
  useContext,
  forwardRef,
} from 'react'
import { UrlServicesContext } from 'components/UrlServicesContext'
import { Redirect } from 'react-router-dom'

import {
  withStyles,
  makeStyles,
  ThemeProvider,
  createTheme,
} from '@material-ui/core/styles'
import { Search, ArrowRightAlt, CheckBox, Today } from '@material-ui/icons'
import axios from 'axios'
import MaterialTable, { MTableBodyRow } from 'material-table'
import { Alert, Skeleton } from '@material-ui/lab'
import {
  Button,
  Grid,
  Box,
  Snackbar,
  Slide,
  Dialog,
  DialogContent,
  DialogActions,
  TextField,
} from '@material-ui/core'
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import Moment from 'moment'

import {
  cardBodyStyle,
  themeCss,
} from 'assets/jss/material-dashboard-react/components/cardBodyStyle'

const useStyles = makeStyles(cardBodyStyle)

const defaultMaterialTheme = createTheme(themeCss)

const useStyles2 = makeStyles({
  tableRow: { '&:hover': { backgroundColor: 'rgb(232, 244, 253)!important' } },
})

const MuiDialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(DialogContent)

const MuiDialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(DialogActions)

export default function TestApplicantsSelect(props) {
  const classes = useStyles()
  const classes2 = useStyles2()

  const [errorServer, setErrorServer] = useState(false)
  const [error, setError] = useState(false)
  const [openAlert, setOpenAlert] = useState(false)
  const [mensaje, setMensaje] = useState('')
  const [returnLogin, setReturnLogin] = React.useState(false)
  const [managePasswords, setManagePasswords] = React.useState(false)
  const [errorDialog, setErrorDialog] = useState(false)
  const [openAlertDialog, setOpenAlertDialog] = useState(false)
  const [mensajeDialog, setMensajeDialog] = useState('')

  const [selectData, setSelectData] = useState([])
  const [validateDateTest, setValidateDateTest] = useState(false)

  let keyAuthorization = localStorage.getItem('Session')

  const { urlServices, keyAplication } = useContext(UrlServicesContext)

  const tableIcons = {
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  }

  const [values, setValues] = useState({
    yearFrom: null,
    presentationDay: '',
    startTimeDay: '',
    endTimeDay: '',
    errorYearFrom: false,
    errorPresentationDay: false,
    errorStartTimeDay: false,
    errorEndTimeDay: false,
  })

  const handleChange = (prop) => (event) => {
    setValues({
      ...values,
      [prop]: event.target.value,
      errorStartTimeDay: false,
      errorEndTimeDay: false,
    })
  }

  const [state] = useState({
    columns: [
      {
        title: 'Nombre',
        field: 'name',
        render: (rowData) => {
          return <span>{rowData.name + ' ' + rowData.lastName}</span>
        },
        width: '60%',
        cellStyle: {
          // whiteSpace: "nowrap",
          border: '1px solid rgb(241, 241, 241)',
          fontSize: 14,
        },
      },
      {
        title: 'Identificación',
        field: 'documentId',
        width: '10%',
        cellStyle: {
          // whiteSpace: "nowrap",
          border: '1px solid rgb(241, 241, 241)',
          fontSize: 14,
          textAlign: 'center',
        },
      },
      {
        title: 'Correo electrónico',
        field: 'email',
        render: (rowData) => {
          return (
            <Fragment>
              <span style={{ fontSize: 12 }}>
                {rowData.email !== '' ? rowData.email : 'SIN REGISTRAR'}
              </span>
            </Fragment>
          )
        },
        width: '30%',
        cellStyle: {
          // whiteSpace: "nowrap",
          border: '1px solid rgb(241, 241, 241)',
          fontSize: 14,
          textAlign: 'center',
        },
      },
    ],
  })

  const handleDateChangeFrom = (event) => {
    setValues({
      ...values,
      yearFrom: event ? event : null,
      presentationDay: event ? Moment(event).format('YYYY-MM-DD') : '',
      errorYearFrom: false,
    })

    setOpenAlertDialog(false)
  }

  useEffect(() => {
    setManagePasswords(props.id.managePasswords)
  }, [])

  const HandleSelect = (data) => {
    setSelectData(data)
    setValidateDateTest(true)
  }

  const submitSave = async () => {
    setOpenAlertDialog(false)
    let n = 0

    if (values.presentationDay === '') {
      setValues({ ...values, errorPresentationDay: true })
      setMensajeDialog('El campo "Fecha" es obligatorio.')
      setOpenAlertDialog(true)
      setErrorDialog('error')
      return
    }

    if (values.startTimeDay === '') {
      setValues({ ...values, errorStartTimeDay: true })
      setMensajeDialog('El campo "Hora de inicio" es obligatorio.')
      setOpenAlertDialog(true)
      setErrorDialog('error')
      return
    }

    if (values.endTimeDay === '') {
      setValues({ ...values, errorEndTimeDay: true })
      setMensajeDialog('El campo "Hora fin" es obligatorio.')
      setOpenAlertDialog(true)
      setErrorDialog('error')
      return
    }

    if (selectData.length > 0) {
      await selectData.forEach((items) => {
        const dataValues = {
          userId: items.id,
          testId: props.id.id,
          presentationDay: values.presentationDay, // Ya en formato YYYY-MM-DD
          startTimeDay: formatTime(values.startTimeDay), // En formato HH:MM:SS
          endTimeDay: formatTime(values.endTimeDay), // En formato HH:MM:SS
          managePasswords: managePasswords,
        }

        axios
          .post(`${urlServices}tests-users`, dataValues, {
            headers: {
              application: keyAplication,
              Authorization: 'Bearer ' + keyAuthorization,
            },
          })
          .then((response) => {
            if (selectData.length === n) {
              //setRows([])
              props.callback()
              setMensaje('Candidato(s) asignado(s) con éxito.')
              setOpenAlert(true)
              setError('success')
              setValidateDateTest(false)
            }
          })
          .catch((e) => {
            if (e.response.status === 401) {
              setTimeout(() => {
                localStorage.clear()
                setReturnLogin(true)
              }, 200)
            } else {
              //setRows([])
              setErrorServer(true)
              console.log(e)
            }
          })

        n++
      })
    }
  }

  const validateTimeFormat = (time) => {
    const timeRegex = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/
    return timeRegex.test(time)
  }

  // Formatear horas de "8:00" a "08:00:00"
  const formatTime = (time) => {
    if (!time) return '00:00:00'
    const [hours, minutes] = time.split(':')
    return `${hours.padStart(2, '0')}:${(minutes || '00').padStart(2, '0')}:00`
  }

  const handleCloseDialog = () => () => {
    setValidateDateTest(false)
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    setOpenAlert(false)
  }

  if (returnLogin) {
    return <Redirect to="/" />
  }

  return (
    <Fragment>
      <Grid container spacing={1} className={classes.containerProfile}>
        {errorServer && (
          <Grid item xs={12} sm={12}>
            <Alert severity="error">
              Error en la consulta con el servidor.
            </Alert>
          </Grid>
        )}
        {props.loader ? (
          <Grid item xs={12} sm={12}>
            <Box sx={{ width: '100%' }}>
              <Skeleton width="100%" height={300} />
            </Box>
          </Grid>
        ) : (
          <Fragment>
            <Grid item xs={12} sm={12}>
              <Alert severity="info" icon={<CheckBox fontSize="inherit" />}>
                <b>
                  CANDIDATOS DISPONIBLES
                  <span style={{ marginLeft: 5, fontSize: 12 }}>
                    (Total: {props.users.length})
                  </span>
                </b>
              </Alert>
            </Grid>
            <Grid item xs={12} sm={12}>
              <MaterialTable
                title=""
                columns={state.columns}
                style={{
                  boxShadow: 'unset',
                  border: '1px solid rgb(241, 241, 241)',
                }}
                data={props.users}
                localization={{
                  toolbar: {
                    // nRowsSelected: '{0} row(s) selected',
                    searchTooltip: 'Filtrar',
                    searchPlaceholder: 'Buscar',
                  },
                  pagination: {
                    labelRowsSelect: 'Filas',
                    labelDisplayedRows: ' {from}-{to} de {count}',
                    firstTooltip: 'Primera página',
                    previousTooltip: 'Previo',
                    nextTooltip: 'Siguiente',
                    lastTooltip: 'Ultima página',
                  },
                  header: {
                    actions: ' --- ',
                  },
                  body: {
                    emptyDataSourceMessage: 'No hay datos.',
                    filterRow: {
                      filterTooltip: 'Filtro',
                    },
                  },
                }}
                actions={[
                  /* {
                            icon: "edit",
                            tooltip: "Editar",
                            onClick: (event, rowData) => {
                              setOpenEditQuestion(true);
                              setIdRow(rowData);
                            },
                          },*/
                  {
                    tooltip: 'Registrar selección',
                    icon: 'refresh',
                    onClick: (evt, data) => HandleSelect(data),
                  },
                ]}
                icons={tableIcons}
                options={{
                  showTextRowsSelected: false,
                  selection: true,
                  search: true,
                  padding: 1,
                  filtering: false,
                  actionsColumnIndex: -1,
                  pageSize: 10,
                  headerStyle: {
                    background: '#F2F2F2',
                    padding: '1%',
                    fontWeight: 'bold',
                    textAlign: 'center',
                  },
                  cellStyle: { border: '1px solid #DDDDDD' },
                }}
                components={{
                  Action: (props) => {
                    if (props.action.icon === 'refresh') {
                      return (
                        <Button
                          onClick={(event) =>
                            props.action.onClick(event, props.data)
                          }
                          className={classes.buttonContactGreen}
                          endIcon={<ArrowRightAlt />}
                        >
                          Agregar
                        </Button>
                      )
                    }
                  },
                  Row: (props) => (
                    <MTableBodyRow className={classes2.tableRow} {...props} />
                  ),
                }}
              />
            </Grid>
          </Fragment>
        )}
      </Grid>
      <Snackbar
        open={openAlert}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        onClose={handleClose}
      >
        <Slide direction="up" in={openAlert} mountOnEnter unmountOnExit>
          <Alert
            onClose={handleClose}
            severity={error === 'error' ? 'error' : 'success'}
            elevation={6}
            variant="filled"
          >
            {mensaje}
          </Alert>
        </Slide>
      </Snackbar>
      <Dialog
        fullWidth
        maxWidth="xs"
        onClose={handleCloseDialog()}
        aria-labelledby="customized-dialog-title"
        open={validateDateTest}
        PaperProps={{
          classes: { root: classes.DialogStyle },
        }}
      >
        <MuiDialogContent dividers>
          <div className={classes.cardBrancheViewTitle} style={{ padding: 20 }}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12}>
                <div className={classes.titleCardFilter}>
                  Agregar fecha y hora
                </div>
                <div className={classes.lineBottom}></div>
                <Alert severity="info">
                  Fecha y hora que se activará la prueba.
                </Alert>
              </Grid>
              <Grid xs={12} md={8}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <ThemeProvider theme={defaultMaterialTheme}>
                    <KeyboardDatePicker
                      id="date-picker-dialog"
                      label="Desde"
                      onChange={handleDateChangeFrom}
                      value={values.yearFrom}
                      format="yyyy-MM-dd"
                      // views={["year"]}
                      animateYearScrolling={true}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                      variant="inline"
                      keyboardIcon={<Today className={classes.iconTheme} />}
                      autoComplete="off"
                      //InputProps={{ readOnly: true }}
                      autoOk
                      //minDate={new Date()}
                      minDateMessage={false}
                      maxDateMessage={false}
                      error={values.errorYearFrom}
                    />
                  </ThemeProvider>
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  name="startTimeDay"
                  value={values.startTimeDay}
                  error={
                    values.errorStartTimeDay ||
                    (!validateTimeFormat(values.startTimeDay) &&
                      values.startTimeDay)
                  }
                  onChange={handleChange('startTimeDay')}
                  fullWidth
                  required
                  label="Hora de inicio (HH:MM)"
                  margin="dense"
                  autoComplete="off"
                  placeholder="Ej: 08:00"
                  helperText={
                    !validateTimeFormat(values.startTimeDay) &&
                    values.startTimeDay
                      ? 'Formato inválido. Use HH:MM'
                      : ''
                  }
                  inputProps={{
                    pattern: '([01]?[0-9]|2[0-3]):[0-5][0-9]',
                    title:
                      'Por favor ingrese la hora en formato HH:MM (ej: 08:00)',
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  name="endTimeDay"
                  value={values.endTimeDay}
                  error={
                    values.errorEndTimeDay ||
                    (!validateTimeFormat(values.endTimeDay) &&
                      values.endTimeDay)
                  }
                  onChange={handleChange('endTimeDay')}
                  fullWidth
                  required
                  label="Hora fin (HH:MM)"
                  margin="dense"
                  autoComplete="off"
                  placeholder="Ej: 17:00"
                  helperText={
                    !validateTimeFormat(values.endTimeDay) && values.endTimeDay
                      ? 'Formato inválido. Use HH:MM'
                      : ''
                  }
                  inputProps={{
                    pattern: '([01]?[0-9]|2[0-3]):[0-5][0-9]',
                    title:
                      'Por favor ingrese la hora en formato HH:MM (ej: 17:00)',
                  }}
                />
              </Grid>
              <Grid item xs={12} md={12} style={{ marginTop: 3 }}>
                <center>
                  <Button
                    className={classes.buttonSubmit2}
                    onClick={submitSave}
                  >
                    Registrar
                  </Button>
                </center>
                {openAlertDialog && (
                  <Alert
                    severity={errorDialog === 'error' ? 'error' : 'success'}
                    style={{ marginTop: 5 }}
                  >
                    {mensajeDialog}
                  </Alert>
                )}
              </Grid>
            </Grid>
          </div>
        </MuiDialogContent>
        <MuiDialogActions>
          <Button
            className={classes.buttonRight}
            onClick={handleCloseDialog()}
            style={{ marginRight: 25 }}
          >
            Cerrar
          </Button>
        </MuiDialogActions>
      </Dialog>
    </Fragment>
  )
}
